import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface ICountPositionRequest extends IBaseRequest {
    server: string;
    session: string;
    timestamp?: string;
    toXml(): string;
}

export class CountPositionRequest extends BaseRequest implements ICountPositionRequest {
    timestamp?: string;

    constructor(
        server: string,
        session: string,
        timestamp?: string
    ) {
        super(server, session);
        this.timestamp = timestamp;
    }

    toXml(): string {
        var parameters = super.toXml();
        parameters += this.makeNode(this.timestamp, 'timestamp');
        return super.wrapperXml("CountPosition", parameters);
    }
}
